module.exports = __webpack_public_path__ + "labioplastika_1_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/labioplastika_1_after_tn.jpg
// module id = 1535
// module chunks = 0